import { RHFTextInput } from 'components/input/RHFTextInput';
import { Flex, Grid } from 'components/layout';
import { Typography } from 'components/typography';

/**
 * Tai LTL Value & Liability section.
 */
export function ValueSection() {
  return (
    <Flex direction='col' gap='md' className='w-full mx-0'>
      <Typography
        variant='h5'
        className='text-neutral-800 font-semibold whitespace-nowrap'
      >
        Value & Liability
      </Typography>

      <Grid cols='2' gap='lg' className='w-full mx-0'>
        {/* Declared Value */}
        <div className='relative'>
          <RHFTextInput
            name='ltl.value.declaredValue'
            label='Declared Value'
            inputType='number'
            placeholder='0.00'
            options={{ valueAsNumber: true, min: 0 }}
            required={false}
            inputClassName='pl-7'
          />
          <span className='absolute left-3 top-[30px] text-neutral-500 pointer-events-none'>
            $
          </span>
        </div>

        {/* Deductible Value */}
        <div className='relative'>
          <RHFTextInput
            name='ltl.value.deductibleValue'
            label='Deductible Value'
            inputType='number'
            placeholder='0.00'
            options={{ valueAsNumber: true, min: 0 }}
            required={false}
            inputClassName='pl-7'
          />
          <span className='absolute left-3 top-[30px] text-neutral-500 pointer-events-none'>
            $
          </span>
        </div>
      </Grid>
    </Flex>
  );
}
